import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { compose} from 'recompose';
// core components
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CardHeader from "../../components/Card/CardHeader";

import loginPageStyle from "../../assets/jss/material-dashboard-pro-react/views/loginPageStyle";
import "src/assets/scss/firebase-ui/firebase-ui.css"
var firebase = require("firebase");
var firebaseui = require("firebaseui");
import { connect } from 'react-redux';
import * as types from 'src/types';
import { AppSection } from "src/types";


interface ILogInProps
{
    classes:any;
    connect:types.IState;
}
interface ILogInState
{
    cardAnimaton:string;
}
class LoginPage extends React.Component<ILogInProps,ILogInState> {
  constructor(props:ILogInProps) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden"
    };
  }
  timeOutFunction:any;
  ui:any;
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    let me = this;
    /*this.timeOutFunction = setTimeout(
      function() {
        me.setState({ cardAnimaton: "" });
      }.bind(me),
      200
    );*/
  
    window['ui'] =  firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
  
    let signInSuccessUrl = "/pages/loggingin"

   // let signInSuccessUrl = '/'+nv.redirect;
    var uiConfig = {
      signInSuccessUrl:signInSuccessUrl,
      callbacks:{
        signInSuccess(currentUser, credential, redirectUrl)
        {
          console.log("signInSuccess", currentUser,redirectUrl)
        },
        signInFailure(error)
        {
            console.error('Sign in error',error)
        },
      signInSuccessWithAuthResult: function(authResult, redirectUrl) {
        console.log("signInSuccessWithAuthResult",redirectUrl)
        types.ViewState.navigate(types.ViewState.getDefaultHash(types.AppSection.LoggingIn));
          // If a user signed in with email link, ?showPromo=1234 can be obtained from
          // window.location.href.
          // ...
          //debugger;
          //setTimeout(()=>{
            //types.ViewState.navigate(types.ViewState.getDefaultHash(types.AppSection.NewTrack)+'/start');
          //},1)

         // return true;
        
      },
    },
      credentialHelper:firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
     
    
      /*credentialHelper:firebaseui.auth.CredentialHelper.GOOGLE_YOLO,*/  
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      // Terms of service url.
      tosUrl: "https://castablog.com/www/terms.html",
        // Privacy policy url/callback.
        privacyPolicyUrl: function() {
          window.location.assign('https://castablog.com/www/privacy.html');
        }
    };
 
    window['ui'].start("#firebaseui-auth-container", uiConfig);
  

  }
  componentWillUnmount(){
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {



    const { classes } = this.props;
    
    
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login >
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="rose"
                >
                  <h4 className={classes.cardTitle}>Log in</h4>
                  
                </CardHeader>
                <CardBody>
                  <div id="firebaseui-auth-container" />
                  <div id="loader"></div>
                </CardBody>
                
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}


LoginPage['propTypes'] = {
  classes: PropTypes.object.isRequired
};

export function mapStateToProps(state: types.IState) {
  //withStyles(loginPageStyle)(LoginPage)
  return {
    connect:state
    
  }
}
/*
export function mapDispatchToProps(dispatch: Dispatch<actions.EnthusiasmAction>) {
  return {
    onIncrement: () => dispatch(actions.incrementEnthusiasm()),
    onDecrement: () => dispatch(actions.decrementEnthusiasm()),
  }
}*/

//export default connect(mapStateToProps, mapDispatchToProps)(Hello);

export default compose(
  //@ts-ignore
  withStyles(loginPageStyle),
  connect(mapStateToProps, null)
)(LoginPage);
//export default connect(mapStateToProps,null, withStyles(loginPageStyle)(LoginPage));
 


// WEBPACK FOOTER //
// ./src/views/pages/LoginPage.tsx